export function scrubData(value, displayValue) {
  return value ? displayValue : undefined;
}
